
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flips/stats",
      function () {
        return require("private-next-pages/flips/stats.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flips/stats"])
      });
    }
  